(ns humbleai.belt.csv
  (:require [clojure.string :as str]
            [clojure.string :as str])
  #?(:clj
     (:import [java.time Instant LocalDateTime ZoneId ZoneOffset ZonedDateTime]
              [java.time.format DateTimeFormatter]
              (java.util Date))
     :cljs
     (:import [goog.date DateTime]
              [goog.i18n DateTimeFormat])))

(defonce utf8-bom "\uFEFF")
(def excel-compatible-datetime-format "yyyy-MM-dd HH:mm:ss")
(defn- dquote-wrap [s] (str \" (str/replace s #"\"" "\"\"") \"))
(defprotocol CSValue (emit* [x]))

(def datetime-formatter
  #?(:clj  (-> (DateTimeFormatter/ofPattern excel-compatible-datetime-format)
               (.withZone (ZoneId/of "UTC")))
     :cljs (goog.i18n.DateTimeFormat. excel-compatible-datetime-format)))

#?(:clj
   (extend-protocol CSValue
     String
     (emit* [this] (dquote-wrap this))
     Number
     (emit* [this] this) ;; leave numbers alone
     Boolean
     (emit* [this] this)
     Instant
     (emit* [this] (.format ^DateTimeFormatter datetime-formatter this))
     Date
     (emit* [this] (emit* (.toInstant this)))
     LocalDateTime
     (emit* [this] (emit* (.toInstant this ZoneOffset/UTC)))
     ZonedDateTime
     (emit* [this] (emit* (.toInstant this)))
     Object ;; catch-all (redirect to String)
     (emit* [this] (emit* (str this)))))

#?(:cljs
   (extend-protocol CSValue
     string
     (emit* [this] (dquote-wrap this))
     number
     (emit* [this] this)
     boolean
     (emit* [this] this);; leave numbers alone
     js/Date
     (emit* [this] (emit* (goog.date.DateTime. this)))
     goog.date.DateTime
     (emit* [this] (.format ^goog.i18n.DateTimeFormat datetime-formatter this))
     object
     (emit* [this] (str this))))

(extend-protocol CSValue
  nil
  (emit* [_] ""))

;;-------------PUBLIC API--------------------------------------------
(defn generate-str
  "Main entry point for generating CSV.
   The 2-arg arity takes unnamed/raw values (i.e. a list of lists),
   and produces a header-less CSV. The 3-arg arity, takes two lists of
   maps (columns VS data), and produces a CSV with a header row.
   The columns must contain either a `:key` or a `:render` entry denoting
   where to find the relevant value in the row map."
  ([data-rows {:keys [sep utf8-bom?]
               :or   {sep \,}}]
   (if-not (seq data-rows)
     ""
     (str
      (when utf8-bom? utf8-bom)
      (->> (for [row data-rows]
             (map #(some-> % emit*) row))
           (map (partial str/join sep))
           (str/join \newline))
      \newline)))
  ([cols data-rows {:keys [sep utf8-bom?]
                    :or   {sep \,}}]
   (when (seq data-rows)
     (str
      (when utf8-bom? utf8-bom)
      (->> (for [row data-rows]
             (map #(when-some [val-fn (or (:key %) (:render %))]
                     (emit* (val-fn row)))
                  cols))
           (cons (map :header cols))
           (map (partial str/join sep))
           (str/join \newline))
      \newline)))) ;; newline at the end
